/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningLoginResponseDto
 */
export interface SigningLoginResponseDto {
    /**
     * Server-side session ID for this signing flow
     * @type {string}
     * @memberof SigningLoginResponseDto
     */
    signingSessionId: string;
    /**
     * Whether a certificate matching the requested signature type was found
     * @type {boolean}
     * @memberof SigningLoginResponseDto
     */
    certificateAvailable: boolean;
}

/**
 * Check if a given object implements the SigningLoginResponseDto interface.
 */
export function instanceOfSigningLoginResponseDto(value: object): value is SigningLoginResponseDto {
    if (!('signingSessionId' in value) || value['signingSessionId'] === undefined) return false;
    if (!('certificateAvailable' in value) || value['certificateAvailable'] === undefined) return false;
    return true;
}

export function SigningLoginResponseDtoFromJSON(json: any): SigningLoginResponseDto {
    return SigningLoginResponseDtoFromJSONTyped(json, false);
}

export function SigningLoginResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningLoginResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signingSessionId': json['signingSessionId'],
        'certificateAvailable': json['certificateAvailable'],
    };
}

export function SigningLoginResponseDtoToJSON(json: any): SigningLoginResponseDto {
    return SigningLoginResponseDtoToJSONTyped(json, false);
}

export function SigningLoginResponseDtoToJSONTyped(value?: SigningLoginResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signingSessionId': value['signingSessionId'],
        'certificateAvailable': value['certificateAvailable'],
    };
}

